import { Button, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { useState } from "react";
import type { BackupMasterApplicationLogs } from "../../../../api/types/integrationsTypes";
import LogDetailsDialog from "../../../common/syncLogs/LogDetailsDialog";
import LogsTableWrapper from "../../../common/syncLogs/LogsTableWrapper";
import LogStatusIcon from "../../../common/syncLogs/LogStatusIcon";
import type { LogsTableRowData } from "./dataBackupLogsTableDataProvider";
import { getRows } from "./dataBackupLogsTableDataProvider";

interface Props {
  logItems: BackupMasterApplicationLogs[];
}

interface LogsTableRowProps extends LogsTableRowData {
  onView: (details: BackupMasterApplicationLogs) => void;
}

const LogsTableRow = ({ severity, completed, description, details, onView }: LogsTableRowProps) => {
  const handleViewClick = () => onView(details);

  return (
    <TableRow hover>
      <TableCell width="10%">
        <LogStatusIcon severity={severity} />
      </TableCell>
      <TableCell>{completed}</TableCell>
      <TableCell>{description}</TableCell>
      <TableCell align="right" className="LogsTable-actions" width="15%" padding="checkbox">
        <Button variant="text" color="primary" onClick={handleViewClick}>
          View
        </Button>
      </TableCell>
    </TableRow>
  );
};

const LogsTableHeadRow = () => (
  <TableRow>
    <TableCell>Status</TableCell>
    <TableCell>Completed</TableCell>
    <TableCell>Event Type</TableCell>
    <TableCell>Actions</TableCell>
  </TableRow>
);

const DataBackupLogsTable = ({ logItems }: Props) => {
  const [logDetails, setLogDetails] = useState<BackupMasterApplicationLogs>();
  const [showLogDetails, setShowLogDetails] = useState(false);

  const handleViewDetails = (logDetails: BackupMasterApplicationLogs) => {
    setLogDetails(logDetails);
    setShowLogDetails(true);
  };

  const handleLogDetailsClose = () => setShowLogDetails(false);

  const rows = getRows(logItems);

  return (
    <>
      <LogsTableWrapper maxHeight="calc(100vh - 460px)">
        <TableHead>
          <LogsTableHeadRow />
        </TableHead>
        <TableBody>
          {rows.map(({ key, ...row }) => (
            <LogsTableRow key={key} {...row} onView={handleViewDetails} />
          ))}
        </TableBody>
      </LogsTableWrapper>
      <LogDetailsDialog open={showLogDetails} onClose={handleLogDetailsClose} logDetails={logDetails} />
    </>
  );
};

export default DataBackupLogsTable;
